import React from 'react'
import { useSelector } from 'react-redux'
import { Row, Col } from 'antd'
import moment from 'moment'

import { ApplicationState } from 'src/store'
import { Text } from 'src/components/Ant'

import { WrapSectionHeader } from './styles'
import { useTranslation } from 'react-i18next'

function SectionHeader() {
  const {
    reports: {
      reportsResources: {
        R4Header: { data: header }
      }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports
  }))
  const { t } = useTranslation()

  if (!header.length) {
    return null
  }
  const defaultInfo = ' - '

  let status = header[0]?.status
  if ([null, 'NULL'].includes(status)) {
    status = 'underway,approval_pending,conference_pending,closing_pending'
  }
  status =
    status
      .split(',')
      .map(item => t(`common.status.unified.${item}`))
      .join(', ') || ' - '

  const headerStatus = status

  const endedOn =
    moment
      .unix(header[0]?.ended_on)
      .utc()
      .format('DD/MM/YYYY') || defaultInfo
  const headerRequests = header[0]?.requests || 0
  const startedOn =
    moment
      .unix(header[0]?.started_on)
      .utc()
      .format('DD/MM/YYYY') || defaultInfo

  return (
    <WrapSectionHeader>
      <Row>
        <Col span={16}>
          <Text colon id="header" title="web.report.4.header.requests">
            <span id="value">{headerRequests}</span>
          </Text>
        </Col>
        <Col span={8}>
          <Text colon id="header" title="web.report.4.header.started-on">
            <span id="value">{startedOn}</span>
          </Text>
        </Col>
      </Row>
      <Row>
        <Col span={16}>
          <Text colon id="header" title="web.report.4.header.status">
            <span id="value">{headerStatus}</span>
          </Text>
        </Col>
        <Col span={8}>
          <Text colon id="header" title="web.report.4.header.ended-on">
            <span id="value">{endedOn}</span>
          </Text>
        </Col>
      </Row>
    </WrapSectionHeader>
  )
}

export default SectionHeader
